import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PaginationModel, ProductModel, RequestParamModel } from '@coreModels';
import { ApiConstants } from '@coreConstant';
import { ToastService } from '../toast.service';

@Injectable({
  providedIn: 'root',
})
export class FavoritesService {
  constructor(private http: HttpClient, private toastService: ToastService) {}

  getProduct(requestParamModel: RequestParamModel): Observable<any> {
    return this.http
      .get(
        ApiConstants.FAVOURITE_PRODUCT_LIST_URL + requestParamModel.getParams(),
        { observe: 'response' }
      )
      .pipe(
        map((response: any) => {
          const productList = new PaginationModel<ProductModel>();
          const headers = response.headers;
          productList.setHeaders(headers);
          productList.data = response.body.data as ProductModel[];
          return productList;
        }),
        catchError((err: unknown) => {
          this.toastService.showError(err);
          return throwError(() => err);
        })
      );
  }

  updateProductFaviourite(body: any): any {
    return this.http.post(ApiConstants.PRODUCT_SET_AS_FAVOURITE_URL, body).pipe(
      map((response: any) => {
        const responseList = new PaginationModel<any>();
        responseList.data = response.data;
        return responseList;
      }),
      catchError((err) => {
        this.toastService.showError(err);
        throw err;
      })
    );
  }
}
